// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"src-_components-___ErrorContent-module__errorMessage___1hYjW"};